import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';
import {Map} from 'immutable';
import Dispatcher from '../dispatcher';
import DietaryTagActions from '../actions/DietaryTagActions';

class DietaryTagStore extends ReduceStore {
  getInitialState() {
    return Immutable.Map();
  }

  reduce(state, action) {
    switch (action.type) {

      case 'getDietaryTags/fetch':
        let tags = Map(action.tags);
        return {dt: tags.toJS(), udt:state.udt};

      case 'getUserDietaryTags/fetch':
        let userTags = Map(action.user);
        return {dt:state.dt, udt: userTags.toJS()};

      case 'updateUserDietaryTags/set':
        let currentUserTags = Immutable.Map(state);
        let newUserTags = action.newTags;
        currentUserTags.set('udt', newUserTags);
        return currentUserTags.toJS();
        
      default:
        return state;
    }
  }
  
  getDietaryTags() {
    if (this._state.size === 0) {
      DietaryTagActions.getDietaryTags();
    }
    return this._state.dt ? this._state.dt.DietaryTags : null;
  }
  getUserDietaryTags(){
    if (this._state.size === 0 || !this._state.udt){
      DietaryTagActions.getUserDietaryTags();
    }
    return this._state.udt ? this._state.udt : null;
  }
  getItem(id) {
    if (id !== this._state.ID) {
      DietaryTagActions.getItem(id);
    }
    return this._state;
  }

}

const DietaryTagStoreInstance = new DietaryTagStore(Dispatcher);
export default DietaryTagStoreInstance;